import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 * 
 * Edited by Studio Rêveuse to extent functionalty into blocks/copy-to-clipboard.liquid
 * 
 */
class CopyToClipboardComponent extends Component {
  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');
    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;
    const copyButtonText = this.refs.copyButtonText;

    if (copySuccessMessage instanceof Element && copyButtonText instanceof Element) {
      // Hide button text and show success message
      copyButtonText.classList.add('visually-hidden');
      copySuccessMessage.classList.remove('visually-hidden');

      // Revert after 2 seconds
      setTimeout(() => {
        copySuccessMessage.classList.add('visually-hidden');
        copyButtonText.classList.remove('visually-hidden');
      }, 2000);
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
